import request from '@/utils/infrastructure/communication/request';

export async function queryEditActive(payload) {
  return request.post(`/emailTemplate/activate/${payload.id}/${payload.state}`, {});
}
